import { fetchWithAuth, ApiError } from './client';

// Keep startup balance reads independent of the full API/store barrels.
export async function getUserCredits() {
  const data = await fetchWithAuth('/json/user/credits');
  if (data.error) throw new ApiError(data.message || 'Failed to fetch user credits', 400, data);
  return data.credits;
}
